import React, { SVGProps } from 'react';
import type { ColorToken } from '@headout/pixie/tokens';
import { token } from '@headout/pixie/tokens';

const BanSvg = ({
  fill = 'semantic.icon.grey.2',
  ...props
}: SVGProps<SVGSVGElement> & {
  fill?: ColorToken;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9975 5.87904 15.1538 3.84567 13.6541 2.34592C12.1543 0.846176 10.121 0.00251416 8 0ZM2 8C1.99829 6.89868 2.30021 5.8182 2.87259 4.87729C3.44497 3.93639 4.26565 3.17149 5.24444 2.66664C6.22324 2.16179 7.32226 1.93654 8.42074 2.01564C9.51922 2.09474 10.5746 2.47513 11.471 3.115L3.115 11.471C2.38997 10.4588 2.00006 9.24505 2 8ZM8 14C6.75491 14.0002 5.54106 13.6102 4.529 12.885L12.885 4.529C13.5249 5.42537 13.9053 6.48078 13.9844 7.57926C14.0635 8.67774 13.8382 9.77676 13.3334 10.7556C12.8285 11.7344 12.0636 12.555 11.1227 13.1274C10.1818 13.6998 9.10132 14.0017 8 14Z"
      fill={token(`colors.${fill}`)}
    />
  </svg>
);
export default BanSvg;
